import { useImportPurchaseAgreement } from "./useImportPurchaseAgreement";
import PickingUI from "./PickingUI";
import ConfirmUI from "./ConfirmUI";
import ErrorUI from "./ErrorUI";

// Persistent slice — survives parent re-renders and step-navigation
// unmount/remount via the `savedImport` prop. Shape:
//   { result, applied, checked, collapsed }
// Transient slice (state machine, files, progress, errorInfo) stays
// inside the hook.
const ImportFromPDFButton = ({
  onApply,
  isLoading = false,
  savedImport = null,
  onSavedImportChange,
  onFilesPicked,
}) => {
  const { state, fileInputRef, handlers } = useImportPurchaseAgreement({
    onApply,
    savedImport,
    onSavedImportChange,
    onFilesPicked,
  });

  if (state.stage === "error") {
    return <ErrorUI state={state} handlers={handlers} />;
  }

  if (state.stage === "confirm" && state.importData?.result) {
    return <ConfirmUI state={state} handlers={handlers} />;
  }

  return (
    <PickingUI
      state={state}
      handlers={handlers}
      inputRef={fileInputRef}
      isLoading={isLoading}
    />
  );
};

export default ImportFromPDFButton;
